import { modalEndConditionState } from 'Hooks/useModalEndCondition/useModalEndCondition'
import useRouteLeaveGuard from 'Hooks/useRouteLeaveGuard/useRouteLeaveGuard'
import {
  Button,
  MODAL_SIZE_SM,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import { pageState } from '../recoil/state/page'

import {
  exceptionsState,
  senderConfigState,
  taskConditionsState,
  taskPanelFrequencyState,
  taskState
} from '../recoil/state/task'

export const ModalConfirmLeave = () => {
  const intl = useIntl()
  const { nameIsDiry, isDirty, isDirtyDetailAction } = useRecoilValue(taskState)
  const { isDirty: GroupisDirty } = useRecoilValue(modalEndConditionState)
  const { IsDiry: senderConfigStateIsDiry, IsDirty: senderConfigStateIsDirty } =
    useRecoilValue(senderConfigState)
  const { isDirty: consitionStateIsDirty } = useRecoilValue(taskConditionsState)
  const { isDirty: exceptionsStateIsDirty } = useRecoilValue(exceptionsState)
  const { isDirty: taskPanelFrequencyStateIsDirty } = useRecoilValue(
    taskPanelFrequencyState
  )

  const { exitPage } = useRecoilValue(pageState)

  const [prompt, allow, deny] = useRouteLeaveGuard(
    exitPage ||
      (!nameIsDiry &&
        !isDirty &&
        !GroupisDirty &&
        !isDirtyDetailAction &&
        !senderConfigStateIsDirty &&
        !senderConfigStateIsDiry &&
        !consitionStateIsDirty &&
        !exceptionsStateIsDirty &&
        !taskPanelFrequencyStateIsDirty)
  )

  const handleConfirm = () => {
    allow()
  }

  return (
    <Modal
      data-mu-test='modal-confirm-leave'
      show={prompt}
      onClose={deny}
      showClose
      closeOnOverlayClick
      size={MODAL_SIZE_SM}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.MessageOverview.ConfirmExitTitle'
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: 'Load.MessageOverview.ConfirmExitDescription'
          })}
        </p>
      </ModalBody>
      <ModalFoot>
        <Button kind='neutral' onClick={deny} data-mu-test='button-cancel'>
          {intl.formatMessage({ id: 'Load.MessageOverview.Cancel' })}
        </Button>
        <Button
          kind='danger'
          onClick={handleConfirm}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({ id: 'Load.MessageOverview.Exit' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
